export default __webpack_public_path__ + "static/media/newsletterbg.10bc9ad8.jpg";